import { Modal } from 'ant-design-vue';

export const CROPPING_DISPOSITION = Object.freeze({
  archive: {
    hint: 'Планировки, к которым, скорее всего, не вернутся. '
      + 'Исключены из автоматической выдачи резчику. При необходимости можно восстановить.',
    confirmation: 'Вы уверены, что хотите перенести планировку в архив? '
      + 'Используйте архив, если работа больше не планируется. '
      + 'Планировка будет исключена из автоматической выдачи резчику. Её можно восстановить вручную.',
  },
  deferred: {
    hint: 'Работа временно отложена и будет продолжена позже. Планировку можно восстановить вручную. '
      + 'Здесь также отображаются планировки апартаментов на паузе, если включено соответствующее правило.',
    confirmation: 'Вы уверены, что хотите отложить планировку? Работа будет продолжена позже. '
      + 'Планировка будет исключена из автоматической выдачи резчику до ручного восстановления.',
  },
});

export const confirmCroppingDisposition = (disposition, onConfirm) => Modal.confirm({
  title: disposition === 'archive' ? 'Перенести планировку в архив?' : 'Отложить планировку?',
  content: CROPPING_DISPOSITION[disposition].confirmation,
  okText: disposition === 'archive' ? 'В архив' : 'Отложить',
  cancelText: 'Отмена',
  centered: true,
  mask: true,
  maskClosable: false,
  onOk: onConfirm,
});
